import $ from 'jquery';

var POLL_INTERVAL = 30000;
var pollTimer = null;

function categoryIcon(category) {
  var icons = {
    talent_match: 'fa-users',
    duplicate: 'fa-copy',
    rescore_done: 'fa-chart-line',
    interview_brief: 'fa-clipboard-list',
    skill_taxonomy: 'fa-tags',
    general: 'fa-bell'
  };
  return icons[category] || icons.general;
}

function renderNotification(n) {
  var readClass = n.read ? 'text-muted' : 'fw-semibold';
  var icon = categoryIcon(n.category);
  var href = n.url || ('/notifications/' + n.id + '/mark_read');
  return '<a href="' + escapeHtml(href) + '" class="dropdown-item notification-item ' + readClass + '" ' +
         'data-id="' + n.id + '">' +
         '<div class="d-flex align-items-start">' +
         '<i class="fa-solid ' + icon + ' me-2 mt-1 small"></i>' +
         '<div class="flex-grow-1">' +
         '<div class="small">' + escapeHtml(n.title) + '</div>' +
         (n.body ? '<div class="text-muted smaller" style="font-size:0.75rem;">' + escapeHtml(n.body).substring(0, 80) + '</div>' : '') +
         '<div class="text-muted" style="font-size:0.7rem;">' + escapeHtml(n.time_ago) + ' ago</div>' +
         '</div></div></a>';
}

function escapeHtml(str) {
  if (!str) return '';
  return str.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}

function updateBell(data) {
  var $badge = $('.notification-badge');
  var $list = $('#notification-list');

  if (data.unread_count > 0) {
    $badge.text(data.unread_count > 99 ? '99+' : data.unread_count).show();
  } else {
    $badge.hide();
  }

  if (data.notifications && data.notifications.length > 0) {
    var html = data.notifications.map(renderNotification).join('');
    $list.html(html);
  } else {
    $list.html('<div class="text-center text-muted py-3 small">No notifications</div>');
  }
}

function poll() {
  $.getJSON('/notifications.json', function(data) {
    updateBell(data);
  });
}

function stopPolling() {
  if (pollTimer) {
    clearInterval(pollTimer);
    pollTimer = null;
  }
}

function init() {
  if ($('#notification-bell').length === 0) return;

  poll();
  stopPolling();
  pollTimer = setInterval(poll, POLL_INTERVAL);

  $(document).on('click', '#mark-all-read-btn', function(e) {
    e.preventDefault();
    e.stopPropagation();
    $.post('/notifications/mark_all_read.json', function() {
      $('.notification-badge').hide();
      $('.notification-item').removeClass('fw-semibold').addClass('text-muted');
    });
  });
}

$(window).on('beforeunload', stopPolling);
$(document).ready(init);

export { init, poll };
